<template>
  <div class="organ-card">
    <div class="left">
      <svg-icon :icon-class="'btn-tree'" />
      <!-- <img class="img" src="~_img/organ/organ-img.png" /> -->
    </div>
    <div class="right">
      <div class="orang-title">{{ data.groupName }}</div>
      <div class="orang-item">
        <div class="label">所属部门:</div>
        <div class="text">{{ data.dep || '-' }}</div>
      </div>
      <div class="orang-item">
        <div class="label">角色:</div>
        <div class="text" :title="data.role">{{ data.role }}</div>
      </div>
    </div>
    <div class="btns">
      <div class="default-orang" v-if="active">归属组织</div>
      <div class="active-organ">管理组织</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.organ-card {
  width: 358px;
  height: 135px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(201, 208, 228, 0.4), 0px 1px 5px 0px #E1E8F0;
  border-radius: 4px;
  // border: 2px solid #ffffff;
  padding: 12px 12px 12px 0;
  line-height: 30px;
  position: relative;
  margin: 6px 10px;
  display: flex;

  .left {
    position: relative;
    width: 30px;
    margin-left: 10px;

    .img {
      width: 100%;
    }

    .svg-icon {
      width: 30px;
      height: 30px;
      // color: --theme-color;
    }
  }

  .right {
    flex: 1;

    .orang-title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #344a75;
      margin-left: 14px;
    }

    .orang-item {
      display: flex;
      align-items: center;

      .label {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #636363;
        width: 80px;
        text-align: right;
      }

      .text {
        width: 200px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #333333;
        margin-left: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .btns {
    display: flex;
    align-items: center;
    position: absolute;
    right: 8px;
    bottom: 6px;

    .default-orang,
    .active-organ {
      border-radius: 4px;
      border: 1px solid #456bd1;
      padding: 0 6px;
      line-height: 20px;
      color: #456bd1;
      border-radius: 4px;
    }

    .active-organ {
      border: 1px solid #1ab8a5;
      color: #1ab8a5;
    }

    .default-orang {
      margin: 0 6px;
    }
  }
}
</style>
